/* global jQuery COMPONENTS Plyr */

COMPONENTS.ComponentVideoCallout = (function ($) {
  function ComponentVideoCallout () {
    this.utility = new COMPONENTS.Utility()
    this.$component = $('[data-ecs-component="video-content"]')
    this.plyrElement = $('[data-ecs-components-control="plyr"]')
    this.player = null
  }

  ComponentVideoCallout.prototype.init = function () {
    if (this.plyrElement.length < 1) {
      // there is no player element on the page, bail so we don't crash the JS
      return
    }
    this.player = new Plyr(this.plyrElement.get(0))
  }

  return ComponentVideoCallout
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentVideoCallout = new COMPONENTS.ComponentVideoCallout()
  COMPONENTS.componentVideoCallout.init()
})
